import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import { UIActions } from '../ui/uiSlice';
import useNavigate from '../utils/router/useNavigate';
import useSlug from '../utils/router/useSlug';
import historyPath from '../utils/url/historyPath';
import HistorySidebar from './history/HistorySidebar';
import { VersionChangesWrapper } from './history/VersionChanges';

const POST_HISTORY_REDIRECT_QUERY = gql(/** @complexity 2 */ `
  query PostHistoryRedirect($id: ID!) {
    post(id: $id) {
      id
      isEditing
      # This query doesn't have Apollo cache enabled.
      # eslint-disable-next-line slab-graphql/graphql-no-corrupt-post-content
      version
      lastHistory {
        id
        versionFrom
        versionTo
      }
      ...historyPath_post
      ...VersionChangesWrapper_post
    }
  }
`);

const PostHistoryRedirectView = () => {
  const [postId] = useSlug('postSlug');
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const { data } = useQuery(POST_HISTORY_REDIRECT_QUERY, {
    variables: { id: postId },
    fetchPolicy: 'no-cache',
  });

  const post = data?.post ?? null;

  useEffect(() => {
    dispatch(
      UIActions.openRightPanel(HistorySidebar, {
        postId,
        tab: 'versions',
      }),
    );

    if (!post) {
      return undefined;
    }

    const { isEditing, lastHistory, version } = post;
    let from;
    let to;
    if (isEditing) {
      from = lastHistory?.versionTo ?? 0;
      to = version;
    } else if (lastHistory) {
      from = lastHistory.versionFrom;
      to = lastHistory.versionTo;
    } else {
      return undefined;
    }

    navigate(historyPath(post, from, to), { replace: true });
    return undefined;
  }, [post, postId, dispatch, navigate]);

  return <VersionChangesWrapper post={post} initialTitle="History - Slab" />;
};

export default PostHistoryRedirectView;
